import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";

async function reassignAllTasksToMyTeam(uid: string) {
  return await httpClient.tasks.put("/v1/tasks/store_switcher", {
    body: { uid },
  });
}

export const useStoreSwitcher = (uid: string, updateUser: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => reassignAllTasksToMyTeam(uid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["activity-tasks"] });
      updateUser();
    },
  });
};
